import React from "react";
import { FiPhoneCall } from "react-icons/fi";
import { PiCalendarDotsBold } from "react-icons/pi";
import { formatUSAPrice } from "../../helpers/utils";

export default function PriceAndContactCard({ handleContactClick, handleRequestTourClick, onPreQualified, property }) {
    return (
        <div className="tw-relative  tw-h-full">
            <div className="tw-sticky tw-top-20 tw-bg-white tw-rounded-lg tw-border-1 tw-p-6 tw-h-fit ">
                <div className="tw-mb-6">
                    <p className="tw-text-gray-500 tw-mb-1">Price</p>
                    <h2 className="tw-text-3xl tw-font-bold">${formatUSAPrice(property.price)}</h2>
                </div>
                <button
                    onClick={handleContactClick}
                    className="tw-w-full tw-flex tw-gap-1 tw-items-center tw-justify-center tw-bg-primary hover:tw-bg-primary_hover tw-text-white tw-py-2 tw-rounded tw-mb-4"
                >
                    <FiPhoneCall />
                    Contact Seller
                </button>
                <div>
                    <h3 className="tw-font-medium tw-mb-2">Request a tour</h3>
                    <p className="tw-text-sm tw-text-semi_dark_text tw-mb-2">Live tour only available on:</p>
                    <p className="tw-text-sm tw-text-semi_dark_text tw-font-medium tw-mb-4">Monday – Friday at 10:00am – 5:00pm</p>
                    <button
                        onClick={handleRequestTourClick}
                        className="tw-flex tw-flex-row tw-gap-1 tw-items-center tw-justify-center tw-w-full tw-border hover:tw-bg-slate-200 tw-border-[#000000] tw-text-black tw-py-2 tw-rounded"
                    >
                        <PiCalendarDotsBold />
                        Make Appointment
                    </button>

                    <button
                        onClick={onPreQualified}
                        className="tw-flex tw-flex-row tw-mt-4 tw-gap-1 tw-items-center tw-justify-center tw-w-full hover:tw-bg-slate-200 tw-border tw-border-[#000000] tw-text-black tw-py-2 tw-rounded"
                    >
                        Get Prequalifed
                    </button>
                </div>
            </div>
        </div>
    );
}
